import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React, { useState } from 'react';
import { linkPropTypes } from '../../../propTypes';
import AbandonBasketModal, { abandonBasketModalLabelProps } from '../AbandonBasketModal';
import Button from '../Atoms/Button';

const propTypes = exact({
  tourKey: PropTypes.string.isRequired,
  isCallToBook: PropTypes.bool,
  callToBookText: PropTypes.string,
  isSoldOut: PropTypes.bool,
  soldOutText: PropTypes.string,
  waitingListLink: linkPropTypes,
  bookNowCta: linkPropTypes,
  abandonBasketEnabled: PropTypes.bool,
  abandonBasketModal: abandonBasketModalLabelProps,
  abandonBasketApi: PropTypes.string.isRequired,
});

const defaultProps = {
  isCallToBook: false,
  callToBookText: '',
  isSoldOut: false,
  soldOutText: '',
  waitingListLink: undefined,
  bookNowCta: undefined,
  abandonBasketEnabled: false,
  abandonBasketModal: undefined,
};

function BookNowCta({
  tourKey,
  isCallToBook,
  callToBookText,
  isSoldOut,
  soldOutText,
  waitingListLink,
  bookNowCta,
  abandonBasketEnabled,
  abandonBasketModal,
  abandonBasketApi,
}) {
  const [isAbandonBasketModalOpen, setIsAbandonBasketModalOpen] = useState(false);

  function onClickBookNow() {
    if (abandonBasketEnabled) {
      setIsAbandonBasketModalOpen(true);
    } else {
      window.location.href = bookNowCta.url;
    }
  }

  function renderButton() {
    let button;
    if (isCallToBook) {
      button = <span className="ButtonCta_callToBook">{callToBookText}</span>;
    } else if (isSoldOut && !waitingListLink) {
      button = <span className="ButtonCta_soldOut">{soldOutText}</span>;
    } else if (waitingListLink) {
      button = (
        <Button
          elementType="link"
          modifier="fill"
          text={waitingListLink.title}
          url={waitingListLink.url}
        />
      );
    } else {
      button = (
        <Button modifier="fill" text={bookNowCta.title} handleClick={() => onClickBookNow()} />
      );
    }
    return button;
  }

  return (
    <>
      {renderButton()}
      {abandonBasketEnabled && (
        <AbandonBasketModal
          bookNowUrl={bookNowCta.url}
          isOpen={isAbandonBasketModalOpen}
          labels={abandonBasketModal}
          onClose={() => {
            setIsAbandonBasketModalOpen(false);
          }}
          submitApi={abandonBasketApi}
          tourKey={tourKey}
        />
      )}
    </>
  );
}

BookNowCta.propTypes = propTypes;
BookNowCta.defaultProps = defaultProps;

export default BookNowCta;
